import axios from 'axios';
import tokenService from '../utils/tokenService';
import store from '../store/store';
import { loginFailure } from '../store/slices/authSlice';
import { trackGleapEvent } from '../utils/gleapEvents';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

api.interceptors.request.use(
  (config) => {
    const token = tokenService.getLocalAccessToken();
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

const stripQuery = (url) => {
  if (!url) return '';
  const i = url.indexOf('?');
  return i >= 0 ? url.slice(0, i) : url;
};

api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    const { response, config } = error;
    const status = response?.status;

    if (status === 401) {
      tokenService.removeToken();
      tokenService.removeComp();
      tokenService.removeRole();
      tokenService.removeRolePermissions();
      store.dispatch(loginFailure());
    } else if (status >= 500) {
      trackGleapEvent('api_5xx', {
        url: stripQuery(config?.url),
        status,
        code: response?.data?.code,
      });
    } else if (status >= 400) {
      trackGleapEvent('api_4xx', {
        url: stripQuery(config?.url),
        status,
        code: response?.data?.code,
      });
    }

    return Promise.reject(error);
  }
);

export default api;
